export default __webpack_public_path__ + "static/media/328.a6361c87.jpg";